//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';

import { SamplingCampaignRequestCountry } from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';
import {
  ContentCard,
  DetailLabel,
  DetailRow,
} from '@campaigns/components/campaign-requests/sampling-campaigns/edit/shared/quote-section/SamplingCampaignRequestQuoteSharedStyles';
import Icon from '@components/atoms/icon/Icon';
import {
  BodyBoldText,
  BodyText,
  CaptionText,
} from '@components/atoms/text/Text';
import { DEFAULT_EMPTY_VALUE } from '@constants/DefaultEmptyValues';

interface Props {
  country?: SamplingCampaignRequestCountry;
  insertDescription?: string;
  packagingDescription?: string;
  weightDescription?: string;
}

export const SamplingCampaignRequestDeliverySummary = ({
  country,
  insertDescription,
  packagingDescription,
  weightDescription,
}: Props) => {
  return (
    <ContentCard>
      <BodyBoldText>Delivery</BodyBoldText>

      <DetailRow>
        <DetailLabel>
          <Icon name='box-open' />
          <CaptionText>Packaging</CaptionText>
        </DetailLabel>
        <BodyText>{packagingDescription ?? DEFAULT_EMPTY_VALUE}</BodyText>
      </DetailRow>

      <DetailRow>
        <DetailLabel>
          <Icon name='file' />
          <CaptionText>Insert</CaptionText>
        </DetailLabel>
        <BodyText>{insertDescription ?? DEFAULT_EMPTY_VALUE}</BodyText>
      </DetailRow>

      <DetailRow>
        <DetailLabel>
          <Icon name='globe' />
          <CaptionText>Country</CaptionText>
        </DetailLabel>
        <BodyText>{country ?? DEFAULT_EMPTY_VALUE}</BodyText>
      </DetailRow>

      <DetailRow>
        <DetailLabel>
          <Icon name='scale-balanced' />
          <CaptionText>Weight</CaptionText>
        </DetailLabel>
        <BodyText>{weightDescription ?? DEFAULT_EMPTY_VALUE}</BodyText>
      </DetailRow>
    </ContentCard>
  );
};
